import React from 'react';
import SynioLogo from './SynioLogo';
import { FaArrowLeft } from 'react-icons/fa';
import './Impressum.css';

const Impressum = ({ onBack }) => {
  return (
    <main className="impressum-page">
      <div className="impressum-container">
        <button 
          onClick={onBack}
          className="impressum-back-button"
          aria-label="Zurück zur Startseite"
        >
          <FaArrowLeft className="text-sm" />
          <span>Zurück</span>
        </button>

        <header className="impressum-header">
          <div className="impressum-logo-wrapper">
            <SynioLogo height={60} aria-label="SYNIO Logo" />
          </div>
          <h1 className="impressum-title">Impressum</h1>
          <div className="impressum-title-accent"></div>
        </header>

        <div className="impressum-content">
          <section className="impressum-section">
            <div className="impressum-section-header">
              <h2>Angaben gemäß § 5 TMG</h2>
            </div>
            <div className="impressum-section-content">
              <p>
                <strong>SYNIO</strong><br />
                Synthetic Data Generator<br />
                <br />
                Johannes Goss<br />
                Mailänder Platz 7<br />
                70173 Stuttgart<br />
                Deutschland
              </p>
            </div>
          </section>

          <section className="impressum-section">
            <div className="impressum-section-header">
              <h2>Kontakt</h2>
            </div>
            <div className="impressum-section-content">
              <p>
                E-Mail: <a href="mailto:hello@synio.studio" className="impressum-link">hello@synio.studio</a>
              </p>
            </div>
          </section>

          <section className="impressum-section">
            <div className="impressum-section-header">
              <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            </div>
            <div className="impressum-section-content">
              <p>
                Johannes Goss<br />
                Mailänder Platz 7<br />
                70173 Stuttgart<br />
                Deutschland
              </p>
            </div>
          </section>

          <section className="impressum-section">
            <div className="impressum-section-header">
              <h2>Haftungsausschluss</h2>
            </div>
            <div className="impressum-section-content">
              <div className="impressum-subsection">
                <h3>Haftung für Inhalte</h3>
                <p>
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. 
                  Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte 
                  können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind 
                  wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach 
                  den allgemeinen Gesetzen verantwortlich.
                </p>
              </div>

              <div className="impressum-subsection">
                <h3>Haftung für Links</h3>
                <p>
                  Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren 
                  Inhalte wir keinen Einfluss haben. Deshalb können wir für diese 
                  fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
                  verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
                  der Seiten verantwortlich.
                </p>
              </div>

              <div className="impressum-subsection">
                <h3>Urheberrecht</h3>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen 
                  Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, 
                  Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
                  Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des 
                  jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </section>

          <section className="impressum-section">
            <div className="impressum-section-header">
              <h2>Datenschutz</h2>
            </div>
            <div className="impressum-section-content">
              <p>
                Die Nutzung unserer Webseite ist in der Regel ohne Angabe 
                personenbezogener Daten möglich. Soweit auf unseren Seiten 
                personenbezogene Daten (beispielsweise Name, Anschrift oder 
                E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, 
                stets auf freiwilliger Basis.
              </p>
              <p>
                <strong>Lokale Datenverarbeitung:</strong> SYNIO wurde mit dem 
                Fokus auf Datenschutz und DSGVO-Konformität entwickelt. Alle 
                Funktionen zur Generierung von Synthetic Data werden vollständig 
                lokal in Ihrem Browser ausgeführt. Ihre 3D-Modelle, generierten 
                Bilder und Annotationen verlassen niemals Ihr Gerät und werden 
                nicht an unsere Server übertragen.
              </p>
              <p>
                <strong>Authentifizierung und Datenspeicherung:</strong> Für die 
                Benutzerauthentifizierung und -verwaltung nutzen wir den Dienst 
                Supabase (Supabase Inc., 970 Toa Payoh North #07-04, Singapore 
                318992). Bei der Registrierung und Anmeldung werden folgende 
                personenbezogene Daten an Supabase übermittelt und dort gespeichert:
              </p>
              <ul className="impressum-list">
                <li>E-Mail-Adresse (für Login und Kommunikation)</li>
                <li>Passwort (verschlüsselt gespeichert)</li>
                <li>Registrierungsdatum und letzter Login-Zeitpunkt</li>
              </ul>
              <p>
                Diese Daten werden ausschließlich für die Bereitstellung des 
                Login-Services verwendet. Supabase verarbeitet die Daten im 
                Auftrag gemäß Art. 28 DSGVO. Weitere Informationen zum 
                Datenschutz bei Supabase finden Sie unter: 
                <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer" className="impressum-link">https://supabase.com/privacy</a>
              </p>
              <p>
                Wir weisen darauf hin, dass die Datenübertragung im Internet 
                (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen 
                kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte 
                ist nicht möglich.
              </p>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default Impressum;

